import Vue from "vue";
import axios from "axios";
import router from "./router/index";
import store from "./store/rootState";
import { sync } from "vuex-router-sync";
import App from "./App";

import { i18n, LocalizerPlugin } from "./plugins/i18n";
Vue.use(LocalizerPlugin, { plugin: i18n });

import { VBToggle } from "bootstrap-vue";
Vue.directive("b-toggle", VBToggle);

Vue.prototype.$http = axios;

import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";

sync(store, router);

const app = new Vue({
    store,
    router,
    ...App,
});

if (process.env.NODE_ENV === "production") {
    Vue.config.devtools = false;
    Vue.config.silent = true;
    Vue.config.debug = false;
    Vue.config.productionTip = false;
} else {
    Vue.config.devtools = true;
    Vue.config.silent = false;
    Vue.config.debug = true;
    Vue.config.productionTip = false;
}

app.$mount("#app");

export { app, router, store };
